import OpenWithIcon from '@mui/icons-material/OpenWith';
import SettingsSuggestIcon from '@mui/icons-material/SettingsSuggest';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import LinearProgress from '@mui/material/LinearProgress';
import Modal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import AreaChart from '../../../../shared/common-utilities/charts/AreaChart';
import BarChart from '../../../../shared/common-utilities/charts/BarChart';
import { CostCharts } from '../../../../shared/common-utilities/charts/CostCharts';
import DiffBarChart from '../../../../shared/common-utilities/charts/DiffBarChart';
import DonutChart from '../../../../shared/common-utilities/charts/DonutChart';
import PieChart from '../../../../shared/common-utilities/charts/PieChart';
import TileLayoutComponent from '../../common/TileLayoutComponent/TileLayoutComponent';

import { Button, Checkbox, ListItemText } from '@mui/material';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import CapacityPlanning from '../../common/tile/CapacityPlanning/CapacityPlanning';
import Monitoring from '../../common/tile/Monitoring/Monitoring';
import Outsourcing from '../../common/tile/Outsourcing/Outsourcing';
import TripPlanning from '../../common/tile/TripPlanning/TripPlanning';
import TypeMovements from '../../common/tile/TypeMovements/TypeMovements';
import WarningMessages from '../../common/tile/WarningMessages/WarningMessages';
import CloseIcon from '@mui/icons-material/Close';
import { borderRadius } from '@mui/system';
import Spinner from "../../common/Spinner/Spinner"
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from 'react-router-dom';
import commonApiService from '../../../../shared/common-utilities/services/commonApiService';
import getSetDataService from '../../../../shared/common-utilities/services/getSetDataService';
import movementColorCode from '../../../../jsonStore/colorCode.json'
import { baseUrl, fetchSavedView, fetchStatuseData, getCustomActions } from '../../../../shared/common-utilities/services/commonUrlConsts/commonUrlConsts';
import dataStorageService from '../../../../shared/common-utilities/services/DataStorageService';

let apiService = commonApiService();
let service = getSetDataService();
let dataService = dataStorageService();

const BorderLinearProgress = styled(LinearProgress)(({ theme }) => ({
    height: 5,
    borderRadius: 0,
    // [`&.${linearProgressClasses.colorPrimary}`]: {
    //     backgroundColor: theme.palette.grey[theme.palette.mode === 'light' ? 800 : 100],
    // },
    // [`& .${linearProgressClasses}`]: {
    //     borderRadius: 0,
    //     backgroundColor: theme.palette.mode === 'light' ? '#ccc' : '#C22EDA',
    // },
}));

const ITEM_HEIGHT = 48;

const tileslist = [{
    id: 1,
    defaultPosition: {
        col: 1,
        colSpan: 1,
        rowSpan: 1
    },
    header: "Trip & route planning",
    body: <TripPlanning />
}, {
    id: 2,
    defaultPosition: {
        col: 1,
        colSpan: 1,
        rowSpan: 1
    },
    header: "Capacity and resource planning",
    body: <CapacityPlanning />,
    resizable: 'horizontal'
}, {
    id: 3,
    defaultPosition: {
        col: 2,
        colSpan: 1,
        rowSpan: 1
    },
    header: "Type of Movements",
    body: <TypeMovements />,
    resizable: 'horizontal'
}, {
    id: 4,
    defaultPosition: {
        col: 2,
        colSpan: 1,
        rowSpan: 1
    },
    header: "Outsourcing",
    body: <Outsourcing />,
    resizable: 'horizontal'
}, {
    id: 5,
    defaultPosition: {
        col: 1,
        colSpan: 1,
        rowSpan: 1
    },
    header: "Monitoring & Dispatching",
    body: <Monitoring />,
    resizable: 'horizontal'
}, {
    id: 6,
    defaultPosition: {
        col: 2,
        colSpan: 1,
        rowSpan: 1
    },
    header: "Warning & messages",
    body: <WarningMessages />,
    resizable: 'horizontal'
}];


const Dashboard = () => {
    const [selectedTile, setSelectedTile] = useState([]);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [tiles, setTiles] = React.useState([]);
    const [openModal, setOpenModal] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const movGridDefaultColumnList = service.movementColumnList;
    const userSettingsColumns = 'movements/columnVisible';

    const navigate = useNavigate()
    const dispatch = useDispatch()

    const userID = localStorage.getItem('userID');
    const companyId = localStorage.getItem('companyId')
    // useEffect(() => {
    //     setTimeout(() => {
    //         setIsLoading(false)
    //     }, 1500)
    //     for (const tile of tileslist) {
    //         if (tile.id < 5)
    //             selectedTile.push(tile)

    //         setSelectedTile(selectedTile)
    //     }

    // }, [])

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1500);

        setSelectedTile((prevSelectedTile) => {
            let updatedSelectedTile = [...prevSelectedTile];

            for (const tile of tileslist) {
                if (tile.id < 5) {
                    updatedSelectedTile.push(tile);
                }
            }

            return updatedSelectedTile;
        });
        const movColorCodeList = localStorage.getItem('movColorCodeList')
        if (_.isNil(movColorCodeList)) {
            getColorCode();
        }
        const defaultColumnSetting = localStorage.getItem('defaultColumnSetting')
        const userId = localStorage.getItem("userID")
        const companyId = localStorage.getItem("companyId")

        if ((_.isNil(defaultColumnSetting) || defaultColumnSetting == "undefined") && (userId !== null && companyId !== null)) {
            setUserSettings();
            fetchCustomActionsData();
            fetchStatusData();
        }
        // const columnList = localStorage.getItem(entityName+'TempColumnList')
        // if (_.isNil(columnList)) {
        //setGridColumns('movement');
        // }

    }, []);

    useEffect(() => {
        // tiles = tileslist
        setTiles(selectedTile)
    }, [selectedTile])

    // add color-code to localStorage
    const getColorCode = () => {
        localStorage.setItem('movColorCodeList', JSON.stringify(movementColorCode))
        // apiService.fetchStatusColorCodeData().then(response => {
        //     if (response && response.value) {
        //         // setColorCodeData(response.value);
        //         localStorage.setItem('movColorCodeList', JSON.stringify(response.value))
        //     } else {
        //         // console.error("Response or response.value is undefined");
        //     }
        // });
    }

    const fetchStatusData = () => {
        apiService.get(fetchStatuseData).then(response => {
          let filter = response.value.filter(item => item.type === "Trip").filter(item => item.statusTrip === "Executed");
          dataService.setLocalStorageData("statuses", filter[0].code);
          dataService.setLocalStorageData("statusMetaData", JSON.stringify(response?.value));
        })
    }

    const fetchCustomActionsData = () => {
        apiService.get(getCustomActions).then((response) => {
          dataService.setLocalStorageData('customActions', JSON.stringify(response.value));
        })
    }

    const setUserSettings = () => {
        // const userID = localStorage.getItem("userIdSettings")
        apiService.get(`${baseUrl}/userSettings(${JSON.parse(userID)})/visibleColumnsMetadata`).then(response => {
            if (!_.isNil(response)) {
                localStorage.setItem("defaultColumnSetting", JSON.stringify(response))
            }
            //  else {
            //     const staticColumns = {
            //         "movement": "instructionsExist~qualificationsExist~shipmentNo~kindofMovement~routeGuideCode~customerName~startAction~startDate~startTime~startTimeTill~startAddressName~startAddressCountry~startAddressPostCode~startAddressCity~endAction~endDate~endTime~endTimeTill~endAddressName~endAddressCountry~endAddressPostCode~endAddressCity~quantity~unitOfMeasure~weight~volume~loadingLength~planInfo~statusPreviousMovement~delDatePreviousMovement~onHold~transportType~department~subdepartment~planDepartment~planSubdepartment~serviceLevel~transitDays~fileNo~fileReference~shipmentReference~loadingmargin~startReference~originMajorZone~originMinorZone~endReference~unloadingmargin~destinationMajorZone~destinationMinorZone",
            //         "partialTrip": "tripNo~partialTrip~status~statusDescription~instructionsExist~department~routeGuide~startingDate~startTime~endingDate~endTime~distance~vehicleCode~trailerCode~driver~driverName~subcontractorCode~subcontractorName~lL~weight~volume~planInfo~startCountry~startPostCode~startCity~startZone~endCounty~endPostCode~endCity~endZone~variousResCode~variousResDescription~emptyTrip~multimodalTrip~lastModifiedDateTime~lastModifiedBy~createdDateTime~createdBy",
            //         "route": "instructionsExist~sequenceNo~noOfMovements~status~statusDescription~actionCode~addressname~address~postCode~city~country~fixedActionTime~startingDate~startingTime~startingTimeTill~actionDurationHM~distance~arrivalDate~arrivalTime~departureDate~departureTime~durationHM~kmCounter~actualDistance",
            //         "ptmovement": "instructionsExist~status~shipmentNo~customerName~startAction~startDate~startTime~startTimeTill~startAddressName~startAddressCountry~startAddressPostCode~startAddressCity~endAction~endDate~endTime~endTimeTill~endAddressName~endAddressCountry~endAddressPostCode~endAddressCity~quantity~unitOfMeasure~weight~volume~loadingLength~fileNo~startReference~endReference",
            //         "vehicle": "codeVehicle~numberplate~vehicleType~ownSubcontractor~subcontractor~subcontractorName~mobilePhoneNo~obcActionCode~obcCity~obcPointofTime~obcDriverFullName",
            //         "trailer": "codeTrailer~numberplate~modelType~ownSubcontractor~subcontractor~subcontractorName~obcActionCode~obcCity~obcPointofTime~obcDriverFullName",
            //         "driver": "codeDriver~firstName~lastName~ownSubcontractor~subcontractor~subcontractorName~mobilePhoneNo~obcActionCode~obcCity~obcPointofTime~obcDriverFullName",
            //         "veriousResource": "codeResource~planDepartment~planSubdepartment~dateOutOfUse~planGroupResource",
            //         "container": "codeContainer~type~ownSubcontractor~subcontractor~subcontractorName~obcActionCode~obcCity~obcPointofTime~obcDriverFullName",
            //         "subcontractor": "codeSubcontractor~searchName~name~address~city~postCode~county~phoneNo"
            //     }
            //     localStorage.setItem("defaultColumnSetting", JSON.stringify(staticColumns))
            // }
        })
            .catch(error => {
                console.log(error)
            })
            .finally(() => {
                setIsLoading(false);
            })
    }

    const setGridColumns = (entityName) => {
        const columnList = localStorage.getItem(entityName + 'TempColumnList')
        if (!_.isNil(columnList)) {
            return true;
        }
        apiService.getODataMetadata().then(odataRes => {
            const odataMetadata = odataRes;
            const url = `${process.env.REACT_APP_COMMON_API_URL}entityDefinitions?$filter=entityName eq '${entityName}'`
            apiService.get(url).then(captionRes => {
                const odataCaptionMetadata = captionRes.value[0].properties;
                let tempFieldList = [];
                let measureField = [];
                const filteredData = odataMetadata.children[0].children[0].children.filter(e => e.name == 'EntityType' && e.attributes['Name'] == entityName)
                filteredData[0].children.forEach(e => {
                    if (e.attributes['Type'] == 'Edm.Decimal') {
                        const item = {
                            field: e.attributes['Name'][0].toUpperCase() + e.attributes['Name'].slice(1),
                            type: e.attributes['Type']
                        }
                        measureField.push(item)
                    }
                    if (e.name == 'Property') {
                        const languageCode = localStorage.getItem("languageCode");
                        const caption = odataCaptionMetadata.filter((elem) => elem.name === e.attributes['Name'])[0].captions.filter((elem) => elem.languageCode === parseInt(languageCode))[0]?.caption;
                        const obj = {
                            field: e.attributes['Name'],
                            title: caption ? caption : e.attributes['Name'],
                            type: e.attributes['Type'],
                            visible: true,
                            width: 170,
                            locked: false,
                            order: 'asc',
                            groupBy: false
                        }
                        tempFieldList.push(obj)
                    }
                });
                let obj = {
                    measureColumnsData: [],
                    movMeasureTableColumns: measureField,
                    draggedItem: {}
                }
                localStorage.setItem('movMeasureFilter', JSON.stringify(obj))

                const qualifications = tempFieldList.find(a => a.field === 'qualificationsExist')
                const index = tempFieldList.indexOf(tempFieldList.find(a => a.field === 'qualificationsExist'));
                if (index !== -1) {
                    tempFieldList.splice(index, 1);
                    tempFieldList.unshift(qualifications);
                }
                // tempFieldList.unshift({
                //     field: 'infografics',
                //     title: 'Info',
                //     visible: true,
                //     width: 150,
                //     locked: false,
                //     order: 'asc',
                //     groupBy: false,
                // });
                // tempFieldList.unshift({
                //     field: 'ActionColumn',
                //     title: 'Action',
                //     visible: true,
                //     width: 300,
                //     locked: false,
                //     order: 'asc',
                //     groupBy: false,
                // });

                localStorage.setItem(entityName + 'ColumnList', JSON.stringify(tempFieldList))
                const url = `${fetchSavedView}?$filter=(title eq '${userSettingsColumns}' and userID eq '${userID}')`
                apiService.get(url).then(savedViewRes => {
                    console.log(savedViewRes)
                    if (savedViewRes.value.length > 0) {
                        apiService.get(savedViewRes.value[0]["userMetadata@odata.mediaReadLink"],null,null,null,null, savedViewRes.value[0]["@odata.etag"]).then(readRes => {
                            localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(readRes))
                        })
                    } else {
                        const dCols = JSON.parse(localStorage.getItem("defaultColumnSetting"))
                        const defaultColumnList = tempFieldList.filter(item => {
                            return dCols?.movement.split("~").includes(item.field) || item.field == 'instructionsExist' || item.field == 'qualificationsExist' || item.field == 'ActionColumn'
                        });
                        localStorage.setItem(entityName + 'TempColumnList', JSON.stringify(defaultColumnList))
                    }
                });
            })
                .catch(error => {
                    console.log(error)
                })
        })
            .catch(error => {
                console.error('API error:', error);
            })
    }

    const onSettingClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const onMenuOpen = Boolean(anchorEl);
    const onMenuClose = () => {
        setAnchorEl(null);
    };

    const openPopup = () => {
        setOpenModal(true);
    };

    const onPoupClose = () => {
        setOpenModal(false);
    };

    const onSelectionChange = (value) => {
        let index;
        let tempList = selectedTile
        if (tempList.length > 1) {
            if ((index = tempList.findIndex(x => x.id === value.id)) > -1) {
                tempList.splice(index, 1)
            }
            else {
                tempList.push(value)
            }
            setSelectedTile(tempList);
            setAnchorEl(null);
        }
    };

    const openInNewWindow = (e, routeName, isClose) => {
        if (isClose) {
            window.close();
        } else {
            window.open(routeName, '_blank', '');
        }
    }

    return (
        <>
            {isLoading ? (<Spinner />) : (<></>)
            }
            <Box component="main" id="watermark" className='page-scroll' sx={{ flexGrow: 1, p: 2 }}>
                <Grid container xs={12}>
                    <Grid item xs={12} md={12} lg="6">
                        <Typography gutterBottom variant="h4" sx={{ fontWeight: 'bold' }} component="h2">
                            Dashboard
                        </Typography>
                    </Grid>
                    <Grid item xs={12} md={12} lg="6" sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>


                        <Button variant="outlined" size="small" onClick={openPopup}>Add Widget</Button>
                        <IconButton aria-label="settings" color='primary' sx={{ marginRight: 1, }}
                            id="long-button"
                            aria-controls={onMenuOpen ? 'long-menu' : undefined}
                            aria-expanded={onMenuOpen ? 'true' : undefined}
                            aria-haspopup="true"
                            onClick={onSettingClick}
                        >
                            <SettingsSuggestIcon />
                        </IconButton>
                        <Menu
                            id="long-menu"
                            MenuListProps={{
                                'aria-labelledby': 'long-button',
                            }}
                            anchorEl={anchorEl}
                            open={onMenuOpen}
                            onClose={onMenuClose}
                            PaperProps={{
                                style: {
                                    maxHeight: ITEM_HEIGHT * 4.5,
                                },
                            }}
                        >

                            {tileslist.map((option) => (
                                <MenuItem key={option.id} value={option.header} onChange={() => onSelectionChange(option)}>
                                    <Checkbox sx={{ p: 0, m: 0 }} checked={selectedTile?.findIndex(x => x.id === option.id) > -1} />
                                    <ListItemText primary={option.header} />
                                </MenuItem>
                            ))}
                        </Menu>


                    </Grid>
                </Grid>

                <TileLayoutComponent tiles={tiles} selectedTile={selectedTile} />

                <Box height={50} />
                <CardHeader sx={{ paddingLeft: 0, paddingRight: 0, paddingBottom: 1, }} action={
                    <IconButton aria-label="settings" color='primary' sx={{ marginRight: 1, }} >
                        {/* <SettingsSuggestIcon /> */}
                    </IconButton>
                } title="KPIs" />
                <Grid container spacing={2}>
                    <Grid item xs={6} md={6} lg={3}>
                        {/* sx={{ height: 60 + "vh" }} */}
                        <Card variant="outlined" sx={{ borderRadius: 0 }}>
                            <CardContent>
                                <div className='flex-between'  >
                                    <h3 className='h3' sx={{ m: 0 }}>
                                        Trips per planning department
                                    </h3>
                                    <IconButton aria-label="settings" color='primary' sx={{ margin: 0, p: 0 }} onClick={openPopup} >
                                        <OpenWithIcon />
                                    </IconButton>
                                </div>

                                <DonutChart />

                            </CardContent>

                        </Card>
                    </Grid>
                    <Grid item xs={6} md={6} lg={3}>
                        <Card variant="outlined" sx={{ borderRadius: 0 }}>

                            <CardContent>
                                <div className='flex-between'  >
                                    <h3 className='h3' sx={{ m: 0 }}>
                                        Trips with different status
                                    </h3>
                                    <IconButton aria-label="settings" color='primary' sx={{ margin: 0, p: 0 }} onClick={openPopup} >
                                        <OpenWithIcon />
                                    </IconButton>
                                </div>
                                <DiffBarChart />

                            </CardContent>

                        </Card>
                    </Grid>
                    <Grid item xs={6} md={6} lg={3}>
                        {/* sx={{ height: 60 + "vh" }} */}
                        <Card variant="outlined" sx={{ borderRadius: 0 }}>
                            <CardContent>
                                <div className='flex-between'  >
                                    <h3 className='h3' sx={{ m: 0 }}>
                                        Movements with different status
                                    </h3>
                                    <IconButton aria-label="settings" color='primary' sx={{ margin: 0, p: 0 }} onClick={openPopup}>
                                        <OpenWithIcon />
                                    </IconButton>
                                </div>

                                <BarChart />

                            </CardContent>

                        </Card>
                    </Grid>
                    <Grid item xs={6} md={6} lg={3}>

                        <Card variant="outlined" sx={{ borderRadius: 0 }}>
                            <CardContent>
                                <div className='flex-between'  >
                                    <h3 className='h3' sx={{ m: 0 }}>
                                        Movements by Region
                                    </h3>
                                    <IconButton aria-label="settings" color='primary' sx={{ margin: 0, p: 0 }} onClick={openPopup}>
                                        <OpenWithIcon />
                                    </IconButton>
                                </div>
                                <PieChart />

                            </CardContent>

                        </Card>
                    </Grid>
                    <Grid item xs={6} md={6} lg={3}>
                        {/* backgroundColor: 'tertiary.light', */}
                        <Card variant="outlined" sx={{ borderRadius: 0 }}>
                            <CardContent>

                                <div className='flex-between'  >
                                    <h3 className='h3' sx={{ m: 0 }}>
                                        Avg Loading time
                                    </h3>
                                    <IconButton aria-label="settings" color='primary' sx={{ margin: 0, p: 0 }} onClick={openPopup}>
                                        <OpenWithIcon />
                                    </IconButton>
                                </div>
                                <AreaChart />

                            </CardContent>

                        </Card>
                    </Grid>
                    <Grid item xs={6} md={6} lg={3}>

                        <Card variant="outlined" sx={{ borderRadius: 0 }}>
                            <CardContent>

                                <div className='flex-between'  >
                                    <h3 className='h3' sx={{ m: 0 }}>
                                        Avg Transit time
                                    </h3>
                                    <IconButton aria-label="settings" color='primary' sx={{ margin: 0, p: 0 }} onClick={openPopup}>
                                        <OpenWithIcon />
                                    </IconButton>
                                </div>

                                <AreaChart />

                            </CardContent>

                        </Card>
                    </Grid>
                    <Grid item xs={12} md={12} lg={6}>

                        <Card variant="outlined" sx={{ borderRadius: 0 }}>
                            <CardContent>
                                <div className='flex-between'  >
                                    <h3 className='h3' sx={{ m: 0 }}>
                                        Distribution of transport cost
                                    </h3>
                                    <IconButton aria-label="settings" color='primary' sx={{ margin: 0, p: 0 }} >
                                        <OpenWithIcon />
                                    </IconButton>
                                </div>

                                <CostCharts />

                            </CardContent>

                        </Card>
                    </Grid>


                </Grid>

                <Modal open={openModal} onClose={onPoupClose}>
                    <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: 400, border: '2px solid #3B66B0', bgcolor: '#ffffff', boxShadow: 24, p: 4 }}>
                        <IconButton aria-label="Close" size="small" onClick={onPoupClose} sx={{ position: 'absolute', top: '-20px', right: '-20px', }}>
                            <CloseIcon sx={{ backgroundColor: 'secondary.main', borderRadius: 20, p: 1, width: 40, height: 40 }} />
                        </IconButton>

                        <Typography variant="h6">This Functionality is to Add a new Widget .!!!</Typography>

                    </Box>
                </Modal>

            </Box >
        </>

    )
}


export default Dashboard;
